import { render } from "./MobileApproval.vue?vue&type=template&id=1fceb6ae&scoped=true"
import script from "./MobileApproval.vue?vue&type=script&lang=js"
export * from "./MobileApproval.vue?vue&type=script&lang=js"

import "./MobileApproval.vue?vue&type=style&index=0&id=1fceb6ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fceb6ae"]])

export default __exports__